import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navyDeep text-mutedDark" data-id="element-88" data-mp="3geze367ujv27">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggu1cr6lbz9g" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32onkt3zizq9h">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="36pfsvtwnvp46">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="3uf0phflqmkvx">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-lineDark pt-6 text-xs" data-id="element-93" data-mp="3ud7ddkscv8gj">
          © 2026 Megapack Meteorología Listo — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}